<template>
  <div class="manager-company-records">
    <div class="manager-company-records-layout manager-company-records-layout--full">
      <div class="manager-company-records-main">
        <router-view :key="$route.fullPath" />
      </div>
    </div>
  </div>
</template>

<script>
import '../styles/ManagerCompanyRecordsView.css';

export default {
  name: 'ManagerCompanyRecordsLayout'
};
</script>
